import { type StartMeetingInput } from '@electron/shared/meetings.types';

import { NativeStartRejectedError } from '@/features/electron-api/features/NativeStartRejectedError';

import { electronApis } from '../electron-api';

const CONTEXTKIT_ALREADY_RECORDING_REASON = 'Meeting is already being recorded';

export function logIfContextKitRefusedStartWhileAppIdle({
  payload,
  meetingId,
  error,
}: {
  payload: StartMeetingInput;
  meetingId: string | undefined;
  error: Error;
}) {
  const contextKitIsRecordingAnotherSession =
    error instanceof NativeStartRejectedError &&
    error.message === CONTEXTKIT_ALREADY_RECORDING_REASON;
  if (!contextKitIsRecordingAnotherSession) return;

  electronApis.meetings.logRecordingHealthEvent({
    event_type: 'native_start_refused_while_idle',
    meeting_id: meetingId ?? null,
    start_reason: payload.startReason,
    refused_reason: 'already_recording',
  });
}
